// 客服活码海报：版式照微信客服官方海报（标题 + 圆角点阵 + 圆角定位框 + 中间气泡 + 底部绿色弧形色带）。
// 与 my/kf-livecode/server.mjs 里的 posterScript 同一套画法，改样式两边一起改。
// 中间盖了图标，所以用最高容错 H（可遮挡约 30%）；已用解码程序验证 250px 宽仍能识别。
import QRCode from 'qrcode'

// 二维码本体：圆角点阵 + 圆角定位框 + 中间绿色气泡。海报和纯二维码共用这一份
function drawCode(g, text, x0, y0, size) {
  const { modules } = QRCode.create(text, { errorCorrectionLevel: 'H' })
  const n = modules.size, bits = modules.data
  const rr = (x, y, w, h, r) => { g.beginPath(); g.roundRect(x, y, w, h, r) }
  const c = size / n
  const inFinder = (r, k) => (r < 7 && k < 7) || (r < 7 && k >= n - 7) || (r >= n - 7 && k < 7)
  const logo = Math.ceil(n * 0.22), lo = Math.floor((n - logo) / 2)   // 中间留白给图标
  const inLogo = (r, k) => r >= lo && r < lo + logo && k >= lo && k < lo + logo
  g.fillStyle = '#111'
  for (let r = 0; r < n; r++) for (let k = 0; k < n; k++) {
    if (!bits[r * n + k] || inFinder(r, k) || inLogo(r, k)) continue
    rr(x0 + k * c + c * 0.05, y0 + r * c + c * 0.05, c * 0.9, c * 0.9, c * 0.2); g.fill()   // 点占格子 90%：80% 时缝太宽，部分尺寸扫不出
  }
  for (const [r, k] of [[0, 0], [0, n - 7], [n - 7, 0]]) {        // 定位框：外框 + 实心内块
    const x = x0 + k * c, y = y0 + r * c
    rr(x, y, 7 * c, 7 * c, c * 1.6); g.fill()
    g.fillStyle = '#fff'; rr(x + c, y + c, 5 * c, 5 * c, c * 1.1); g.fill()
    g.fillStyle = '#111'; rr(x + 2 * c, y + 2 * c, 3 * c, 3 * c, c * 0.8); g.fill()
  }
  const cx = x0 + size / 2, cy = y0 + size / 2, R = logo * c / 2 * 0.72   // 中间绿色聊天气泡
  g.fillStyle = '#07c160'
  g.beginPath(); g.ellipse(cx, cy - R * 0.05, R, R * 0.86, 0, 0, Math.PI * 2); g.fill()
  g.beginPath(); g.moveTo(cx - R * 0.55, cy + R * 0.6); g.lineTo(cx - R * 0.75, cy + R * 1.05); g.lineTo(cx - R * 0.15, cy + R * 0.78); g.fill()
  g.fillStyle = '#fff'
  g.beginPath(); g.arc(cx - R * 0.36, cy - R * 0.12, R * 0.11, 0, Math.PI * 2); g.fill()
  g.beginPath(); g.arc(cx + R * 0.36, cy - R * 0.12, R * 0.11, 0, Math.PI * 2); g.fill()
  g.strokeStyle = '#fff'; g.lineWidth = R * 0.13; g.lineCap = 'round'
  g.beginPath(); g.arc(cx, cy + R * 0.08, R * 0.3, Math.PI * 0.15, Math.PI * 0.85); g.stroke()
}

export function drawPoster(cv, text) {
  const S = 2, W = 700, H = 908
  cv.width = W * S; cv.height = H * S
  const g = cv.getContext('2d'); g.scale(S, S)
  const font = '-apple-system, "PingFang SC", "Microsoft YaHei", sans-serif'
  g.fillStyle = '#fff'; g.fillRect(0, 0, W, H)

  g.fillStyle = '#111'; g.textAlign = 'center'; g.textBaseline = 'middle'
  g.font = `600 46px ${font}`
  g.fillText('微信扫码咨询客服', W / 2, 152)

  drawCode(g, text, (W - 380) / 2, 238, 380)

  const grad = g.createLinearGradient(0, 680, 0, H)                  // 底部弧形色带
  grad.addColorStop(0, '#5fd37f'); grad.addColorStop(1, '#3cbc5c')
  g.fillStyle = grad
  g.beginPath(); g.moveTo(0, 672); g.quadraticCurveTo(W / 2, 800, W, 672); g.lineTo(W, H); g.lineTo(0, H); g.fill()
  g.fillStyle = '#fff'; g.font = `600 38px ${font}`
  g.fillText('企业微信 · 微信客服', W / 2, 826)
}

// 纯二维码：跟海报里的码一模一样，白底四周留白，导出 PNG
export function plainQr(text) {
  const cv = document.createElement('canvas'), S = 2, pad = 60, size = 380   // 留白约 4 格，二维码标准要求，太窄大图反而扫不出
  cv.width = cv.height = (size + pad * 2) * S
  const g = cv.getContext('2d'); g.scale(S, S)
  g.fillStyle = '#fff'; g.fillRect(0, 0, size + pad * 2, size + pad * 2)
  drawCode(g, text, pad, pad, size)
  return cv.toDataURL('image/png')
}
